import { type EdgeProps } from '@xyflow/react';

import CustomEdgeBase from '../CustomEdgeBase';

export default function DefaultEdge(props: EdgeProps) {
  return <CustomEdgeBase edgeProps={props} />;
}
